import React, { Component } from 'react';
import fire from '../fire';
import { Grid, Form, Header } from 'semantic-ui-react';

class AddTajweed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tajweedNumber: "",
      tajweedName: "",
      tajweedArticleId: "",
      tajweedYoutubeId: "",
      tajweedSoundCloudId: ""
    };
  }
  

  postTajweed = () => {
    const tajweedsRef = fire.database().ref('tajweeds');

    const item = {
      tajweedNumber: this.state.tajweedNumber,
      tajweedName: this.state.tajweedName,
      tajweedArticleId: this.state.tajweedArticleId,
      tajweedYoutubeId: this.state.tajweedYoutubeId,
      tajweedSoundCloudId: this.state.tajweedSoundCloudId
    }

    tajweedsRef.push(item);

    this.setState({
      tajweedNumber: "",
      tajweedName: "",
      tajweedArticleId: "",
      tajweedYoutubeId: "",
      tajweedSoundCloudId: ""
    });
  }

  handleChange = (e, { name, value }) => {
    this.setState({ 
      [name]: value
    })
  }


  render() {
    return (
      <Grid columns={1}>
        <Grid.Column>
          <Header>Add to New Tajweed Lessons</Header>
        </Grid.Column>
        <Grid.Column>
          <Form onSubmit={this.postTajweed}>
            <Form.Group widths='equal'>
              <Form.Input name="tajweedNumber" type="number" value={this.state.tajweedNumber} placeholder='Enter the Tajweed Number' onChange={this.handleChange}/>
              <Form.Input name="tajweedName" type="text" value={this.state.tajweedName} placeholder='Enter the Tajweed Name' onChange={this.handleChange}/>
              <Form.Input name="tajweedArticleId" type="text" value={this.state.tajweedArticleId} placeholder='Enter the Tajweed Article Id' onChange={this.handleChange}/>
              <Form.Input name="tajweedYoutubeId" type="text" value={this.state.tajweedYoutubeId} placeholder='Enter the Youtube Id' onChange={this.handleChange}/>
              <Form.Input name="tajweedSoundCloudId" type="text" value={this.state.tajweedSoundCloudId} placeholder='Enter the Soundcloud Id' onChange={this.handleChange}/>
            </Form.Group>
            <Form.Group> 
              <Form.Button content='Submit' />
            </Form.Group>
          </Form>
        </Grid.Column>
      </Grid>
    );
  }
}
export default AddTajweed;
